import { QuoteStatus, QUOTE_STATUS } from '@frontend/api';
import type { BadgeProps } from '@frontend/components';

import { QUOTE_STATUS_LABEL } from 'constants/all';

import StatusBadge from './StatusBadge';

const PROPS_BY_STATUS: Record<QuoteStatus, Partial<BadgeProps> | null> = {
  [QUOTE_STATUS.ALL]: null,
  [QUOTE_STATUS.DRAFT]: {
    bg: '#D9D9D9',
    borderColor: '#D9D9D9',
    color: 'feature.secondary',
  },
  [QUOTE_STATUS.OUTSTANDING]: {
    colorScheme: 'success',
  },
  [QUOTE_STATUS.ACCEPTED]: {
    colorScheme: 'success',
    variant: 'solid',
  },
  [QUOTE_STATUS.LOST]: {
    colorScheme: 'error',
    variant: 'solid',
  },
  [QUOTE_STATUS.EXPIRED]: {
    colorScheme: 'error',
  },
  [QUOTE_STATUS.CANCELLED]: {
    bg: 'feature.placeholder',
    borderColor: 'feature.placeholder',
    color: 'feature.onInteraction',
  },
  [QUOTE_STATUS.TRASH]: {
    colorScheme: 'warning',
  },
  [QUOTE_STATUS.UNVIEWED_DRAFT_RFQ]: {
    colorScheme: 'warning',
  },
} as const;

type QuoteStatusBadgeProps = {
  quoteStatus?: QuoteStatus;
} & BadgeProps;

const QuoteStatusBadge = ({ quoteStatus, ...rest }: QuoteStatusBadgeProps) => {
  return (
    <StatusBadge
      status={quoteStatus}
      propsByStatus={PROPS_BY_STATUS}
      labelByStatus={QUOTE_STATUS_LABEL}
      {...rest}
    />
  );
};

export default QuoteStatusBadge;
